import { render, staticRenderFns } from "./Incubadora.vue?vue&type=template&id=69e51a79&scoped=true"
import script from "./Incubadora.vue?vue&type=script&lang=js"
export * from "./Incubadora.vue?vue&type=script&lang=js"
import style0 from "./Incubadora.vue?vue&type=style&index=0&id=69e51a79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e51a79",
  null
  
)

export default component.exports